import FindOut from "./FindOut";

export default FindOut;
